import type { ReservedDatesClientInterface } from './reservedDatesClient.types';
import CorporateReservedDatesClient from './corporateReservedDatesClient';
import type { ClientContext } from '~/services/contextClient';

export default class ReservedDatesClientFactory {
    static createClient(context: ClientContext): ReservedDatesClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateReservedDatesClient(context.teamId);
        }

        throw new Error('Reserved dates are only available at corporate level');
    }
}
